import { render, staticRenderFns } from "./InstructorIcard.vue?vue&type=template&id=a7f5c2f2&"
import script from "./InstructorIcard.vue?vue&type=script&lang=js&"
export * from "./InstructorIcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports